import { useState } from 'react';
import { gossipWallItems } from '@/mocks/articles';

export default function GossipWall() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goTo = (index: number) => {
    setCurrentIndex(index);
  };

  const item = gossipWallItems[currentIndex];

  return (
    <section className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900">
              网友爆料墙
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              真实用户反馈 · 吃瓜群众的真实声音
            </p>
          </div>

          {/* Testimonial Card */}
          <div className="relative">
            <div
              className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10 transition-all duration-500"
              style={{
                transform: `translateX(${(currentIndex - 1) * 4}px)`,
              }}
            >
              {/* Quote Icon */}
              <div className="text-5xl md:text-7xl font-heading text-primary-200 leading-none mb-4">
                &ldquo;
              </div>

              {/* Rating */}
              <div className="flex items-center gap-2 mb-5">
                <div className="flex items-center gap-0.5 px-3 py-1.5 rounded-full bg-foreground-900 text-background-50">
                  <i className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-sm font-semibold ml-1">{item.rating}</span>
                </div>
                <span className="text-xs text-foreground-500">用户真实评分</span>
              </div>

              {/* Content */}
              <p className="text-base md:text-lg text-foreground-800 leading-relaxed font-heading italic">
                {item.content}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 mt-6 pt-5 border-t border-background-200/70">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatarUrl}
                    alt={item.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.author}</p>
                  <p className="text-xs text-foreground-500">{item.date}</p>
                </div>
              </div>

              {/* Navigation Arrows */}
              <div className="flex items-center justify-end gap-2 mt-6">
                <button
                  onClick={() => goTo(currentIndex === 0 ? gossipWallItems.length - 1 : currentIndex - 1)}
                  className="w-10 h-10 rounded-lg border border-background-300 bg-background-50 flex items-center justify-center text-foreground-600 hover:text-foreground-900 hover:border-foreground-400 transition-all cursor-pointer"
                >
                  <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                </button>
                <button
                  onClick={() => goTo((currentIndex + 1) % gossipWallItems.length)}
                  className="w-10 h-10 rounded-lg bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-all cursor-pointer"
                >
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </button>
              </div>
            </div>

            {/* Dots */}
            <div className="flex items-center justify-center gap-2 mt-6">
              {gossipWallItems.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goTo(index)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    index === currentIndex
                      ? 'bg-primary-500 w-6'
                      : 'bg-background-300 hover:bg-background-400'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}